<template>
  <div>
    <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
        v-if="availDocs"
        :items="availDocs"
        :fields="fields"
        @ClickOnDeleteButton="ClickOnDeleteButton"
        @ClickOnEditButton="editItem"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"
        isDelete="true"
        isEdit="true"/>
    <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    <editModal :editItem="selectedAvailDocs"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  data () {
    return {
      fields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'group_id',
          label: this.$i18n.t('Group'),
          sortable: true,
          formatter: (val, key, item) => {
            if (val === 0) {
              return this.$t('All') + '(0)'
            }
            for (let el of this.groups) {
              if (val === el.group_id) {
                return el.group_name + '(' + val + ')'
              }
            }
            return val
          }},
        {key: 'is_enabled', label: this.$i18n.t('Active'), sortable: true, formatter: (val, key, item) => { return val ? this.$t('Yes') : this.$t('No') }},
        {key: 'available_docs',
          label: this.$i18n.t('Available docs'),
          sortable: true,
          formatter: (val, key, item) => { return this.docsEnum(val) }},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedAvailDocs: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      reportsArray: []
    }
  },
  components: {
    editModal
  },
  methods: {
    docsEnum (val) {
      let ret = ''
      if (val & 1) {
        ret += '(' + this.$i18n.t('Invoice') + ') '
      }
      if (val & 2) {
        ret += '(' + this.$i18n.t('VAT invoice') + ') '
      }
      if (val & 4) {
        ret += '(' + this.$i18n.t('Acceptance report') + ')'
      }
      if (val & 8) {
        ret += '(' + this.$i18n.t('Telephony docs') + ')'
      }
      return ret
    },
    docsToArray (val) {
      let ret = []
      if (val & 1) {
        ret.push(1)
      }
      if (val & 2) {
        ret.push(2)
      }
      if (val & 4) {
        ret.push(4)
      }
      if (val & 8) {
        ret.push(8)
      }
      return ret
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', 'Are you sure you want to delete one of "Available docs?"', this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_AVAIL_DOCS_SETTINGS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_AVAIL_DOCS_SETTINGS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    editItem (item) {
      this.selectedAvailDocs = JSON.parse(JSON.stringify(item))
      this.selectedAvailDocs.docs = this.docsToArray(item.available_docs)
      this.$bvModal.show('modalEditAvailDocs')
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    },
    showAdd () {
      this.selectedAvailDocs = {
        group_id: 0,
        id: 0,
        is_enabled: 0,
        available_docs: 0,
        docs: []
      }
      this.$bvModal.show('modalEditAvailDocs')
    }
  },
  computed: {
    groups () {
      return this.$store.getters['Users/GROUPS']
    },
    availDocs () {
      return this.$store.getters['Settings/AVAIL_DOCS_SETTINGS']
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_AVAIL_DOCS_SETTINGS')
    this.$store.dispatch('Users/GET_GROUPS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/contracts/main.vue